<!--大用户 - 大用户历史数据 - 水表历史数据 -->
<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="horizontal" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
        <a-row :gutter="48">
          <!-- 第一排 -->
          <a-col :md="6" :sm="12">
            <a-form-item label="用户编码">
              <a-input v-model="query.userCode" placeholder="请输入用户编码" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户名称">
              <a-input v-model="query.userName" placeholder="请输入用户名称" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用水性质">
              <a-select v-model="query.waterType" placeholder="请选择用水性质" allow-clear>
                <a-select-option :value="1">居民用水</a-select-option>
                <a-select-option :value="2">非居民用水</a-select-option>
                <a-select-option :value="3">特种用水</a-select-option>
                <a-select-option :value="4">其他用水</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="水表编号">
              <a-input v-model="query.waterMeterNumber" placeholder="请输入水表编号" allow-clear />
            </a-form-item>
          </a-col>
          <!-- 第二排 -->
          <a-col :md="6" :sm="12">
            <a-form-item label="水表类型">
              <a-select v-model="query.waterMeterType" placeholder="请选择水表类型" allow-clear>
                <a-select-option :value="1">机械表</a-select-option>
                <a-select-option :value="2">远传表</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="水表口径">
              <a-input v-model="query.waterMeterCaliber" placeholder="请输入水表口径" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="采集时间">
              <a-range-picker style="width: 237px;" :placeholder="['开始日期', '结束日期']" @change="pushOnChange"
                v-model="pushTime" />
            </a-form-item>
          </a-col>
          <!-- 第二排-操作按钮 -->
          <a-col :md="12" :sm="12" style="display: flex;">
            <div style="margin-bottom: 20px;">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="exportHandles()" v-action:export>导出</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id" :bordered="true"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange" :scroll="{ x: 1500 }">
      <span slot="volatilityDifference" slot-scope="text">
        <img style="height: 15px; width: 10px;" :src="text > 0
          ? require('@/assets/bigusers/picture/rise.svg')
          : require('@/assets/bigusers/picture/descend.svg')" />
        {{ Math.abs(text) }}
      </span>
      <span slot="volatilityRatio" slot-scope="text">
        {{ text }}%
      </span>
    </a-table>
  </a-card>
</template>

<script>
import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import mixinViewModule from '@/mixin/common' //选项式混合导入
const columns = [ //表头参数
  {
    title: '用户编码',
    dataIndex: 'userCode',
    width: '150px', // 固定操作列宽度
    fixed: 'left',
    ellipsis: true
  },
  {
    title: '用户名称',
    dataIndex: 'userName',
    width: '150px',
    ellipsis: true
  },
  {
    title: '用户地址',
    dataIndex: 'userAddress',
    width: '150px',
    ellipsis: true
  },
  {
    title: '用水性质',
    dataIndex: 'waterTypeName',
    width: '150px',
    ellipsis: true
  },
  {
    title: '上期用水量(m³)',
    dataIndex: 'previousPeriodUsage',
    width: '150px',
    ellipsis: true
  },
  {
    title: '上期采集时间',
    dataIndex: 'lastCollectionTime',
    width: '200px',
    ellipsis: true
  },
  {
    title: '本期用水量(m³)',
    dataIndex: 'currentUsage',
    width: '150px',
    ellipsis: true
  },
  {
    title: '本期采集时间',
    dataIndex: 'currentIssueTime',
    width: '200px',
    ellipsis: true
  },
  {
    title: '波动差值(m³)',
    dataIndex: 'volatilityDifference',
    width: '150px',
    ellipsis: true,
    scopedSlots: { customRender: 'volatilityDifference' }
  },
  {
    title: '波动比例',
    dataIndex: 'volatilityRatio',
    width: '150px',
    // sorter: true,
    ellipsis: true,
    scopedSlots: { customRender: 'volatilityRatio' }
  },
  {
    title: '推送时间',
    dataIndex: 'pushTime',
    width: '200px',
    ellipsis: true
  },
  {
    title: '水表口径',
    dataIndex: 'waterMeterCaliber',
    width: '150px',
    ellipsis: true
  },
  {
    title: '水表编号',
    dataIndex: 'waterMeterNumber',
    width: '150px',
    ellipsis: true
  },
  {
    title: '水表类型',
    dataIndex: 'waterMeterTypeName',
    width: '150px',
    ellipsis: true
  },
  {
    title: '厂家',
    dataIndex: 'manufacturer',
    width: '150px',
    ellipsis: true
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'AllUserPage',
  data () {
    return {
      //needQuery: false, // 是否在created就执行查询操作
      currentId: '',
      queryUrl: '/smart-water-major-users/major/users/data/data/select/page', //查询url
      deleteUrl: '', //删除url
      exportDataUrl: 'smart-water-major-users/major/users/data/data/select/page/export', //导出url
      exportFileName: '水表历史数据.xlsx', //导出名称
      query: { //查询对象

      },
      columns,
      pushTime: [],
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },
  methods: {
    // 重置
    resetList () {
      this.pagination.current = 1
      this.query = {}
      this.selectedRows = []
      this.pushTime = []
      this.queryList()
    },
    // 获取采集时间
    pushOnChange () {
      if (this.pushTime && this.pushTime.length === 2) {
        this.query.currentIssueTimeBegin = this.pushTime[0].format('YYYY-MM-DD');
        this.query.currentIssueTimeEnd = this.pushTime[1].format('YYYY-MM-DD');
      }
    },
    exportHandles () {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`, {
        params: this.query,
        responseType: 'blob',
        headers: {
          'Authorization': storage.get(ACCESS_TOKEN),
          'Accept': 'application/vnd.ms-excel'
        }
      })
        .then(response => {
          console.log('导出响应:', response);
          const blob = response.data;
          // 下载逻辑
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = this.exportFileName;
          link.click();
          window.URL.revokeObjectURL(url);

          this.$message.success('导出成功');
        })
        .catch(error => {
          console.log('导出失败:', error);
          this.$message.error('下载失败');
        })
        .finally(() => {
          this.resetList();
          this.importLoading = false
        })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
